import React, { ButtonHTMLAttributes, FC, useMemo } from 'react';
import ButtonSize from '../../../enums/ButtonSize';
import ButtonDecoration from '../../../enums/ButtonDecoration';
import * as classes from './Button.module.scss';
import cn from 'classnames';
import Link from '../Link/Link';
import { ButtonLink } from '../../../interfaces/nav/ButtonLink';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: ButtonSize;
  decoration?: ButtonDecoration;
  icon?: JSX.Element;
  iconLeft?: boolean;
  link?: ButtonLink;
}

const Button: FC<ButtonProps> = ({ size, decoration, icon, iconLeft, children, link, ...rest }) => {
  const buttonSize = useMemo(() => {
    if (size === ButtonSize.SMALL) {
      return classes.small;
    }
    return classes.large;
  }, [size]);

  const buttonStyle = useMemo(() => {
    if (decoration === ButtonDecoration.SECONDARY) {
      return classes.secondary;
    }
    return classes.primary;
  }, [decoration]);

  const buttonClassName = useMemo(() => {
    return cn(classes.element, buttonSize, buttonStyle, !!icon && classes.withIcon, iconLeft && classes.iconLeft);
  }, [buttonSize, buttonStyle, icon, iconLeft]);

  const button = () => {
    if (link) {
      return (
        <Link
          path={link.path}
          className={cn(buttonClassName, rest.className)}
          isExternalLink={link.isExternalLink}
          isTargetBlank={link.isTargetBlank}
          title={link.title}
        >
          <div className={classes.buttonText}>{children}</div>
          {!!icon && icon}
        </Link>
      );
    }
    return (
      <button {...rest} className={cn(buttonClassName, rest.className)}>
        <div className={classes.buttonText}>{children}</div>
        {!!icon && icon}
      </button>
    );
  };

  return <>{button()}</>;
};

export default Button;
